"use strict";
/*====================================
  ScenarioNode
=====================================*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* common
--------------------------------*/

var ScenarioNodeType;

(function (ScenarioNodeType) {
  ScenarioNodeType["Text"] = "textScenarioNode";
  ScenarioNodeType["Image"] = "imageScenarioNode";
  ScenarioNodeType["ImageExplanation"] = "imageExplanationScenarioNode";
  ScenarioNodeType["Greeting"] = "greetingScenarioNode";
})(ScenarioNodeType = exports.ScenarioNodeType || (exports.ScenarioNodeType = {}));

var ActionType;

(function (ActionType) {
  ActionType["Id"] = "id";
  ActionType["Url"] = "url";
})(ActionType = exports.ActionType || (exports.ActionType = {}));

exports.GREETING_SCENARIO_NODE_ID = 'greetingScenarioNode'; // 現状、rows1 ~ rows4 が keyに使用される作りになっている

var RowKey;

(function (RowKey) {
  RowKey["Row1"] = "rows1";
  RowKey["Row2"] = "rows2";
  RowKey["Row3"] = "rows3";
  RowKey["Row4"] = "rows4";
})(RowKey = exports.RowKey || (exports.RowKey = {}));
/*====================================
  Variable
=====================================*/


var VariableType;

(function (VariableType) {
  VariableType["Url"] = "url";
  VariableType["Text"] = "text";
})(VariableType = exports.VariableType || (exports.VariableType = {}));

exports.INITIAL_SCENARIO_DESIGN = {
  backgroundColor: '#158ACD',
  greetingScenarioNode: {
    bodyBackColor: '#74acdf',
    bodyButtonColor: '#5091CB',
    bodyTextColor: '#FFFFFF',
    footerBackColor: '#FFFFFF'
  },
  imageExplanationScenarioNode: {
    bodyBackColor: '#FFFFFF',
    bodyTextColor: '#000000'
  },
  richMenuColor: '#74ACE0',
  textScenarioNode: {
    bodyBackColor: '#FFFFFF',
    bodyTextColor: '#000000',
    headerBackColor: '#74acdf',
    headerTextColor: '#FFFFFF',
    initButtonColor: '#74acdf',
    preButtonColor: '#74acdf'
  }
};
exports.INITIAL_SCENARIO_STATE = {
  nodeMap: {},
  keywordsMap: {},
  currentNodeId: exports.GREETING_SCENARIO_NODE_ID,
  previewAction: undefined,
  variables: [],
  design: exports.INITIAL_SCENARIO_DESIGN
};